import styled from "styled-components";

export const CloseButton = styled.button`
  background: transparent;
  padding: 0 0.5em;
  font-size: initial;
  margin-right: 0.5em;
  outline: none;
  border: 0px solid #ddd;
  border: 0px solid #ddd;
  cursor: pointer;
  height: 40px;
  width: 40px;
  margin-right: 0px;
  padding: 12px;
  background: ${(props) => props.theme.secBackground};
  border-radius: 50%;
  margin-top: 4px;
  cursor: pointer;
  &:hover {
    color: ${(props) => props.theme.bgPrimary};
  }
`;
export const Td = styled.div`
  text-align: left;
  padding: 10px 0px;
  margin: 0 30px;
  position: relative;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #d9d9d9;
  &.no,
  &.name {
    border: 1px solid gray;
  }
  &.has {
    border: 2px solid black;
    cursor: pointer;
  }
  &.no,
  &.has {
    text-align: center;
  }
  &.no svg {
    fill: grey;
  }
  &.name {
    text-overflow: "no-wrap";
  }
  &.bold {
    border-bottom: 1px solid #988b8b;
    border-top: 1px solid #988b8b;
  }
  &.actions {
    display: flex;
    justify-content: right;
    overflow-wrap: normal;
    margin-left: auto;
    margin-right: 5px;
    padding: 0;
  }
  &.right {
    text-align: right;
  }
  &:last-child {
    border-bottom: 0 !important;
  }
  .double & {
    // &:nth-child(odd) {
    //   border-right: 1px solid #ccc;
    // }
    &:last-child {
      border-bottom: 0 !important;
    }

    &:last-child,
    &:nth-last-child(2):nth-child(odd) {
      /* Apply styles to second-to-last child in last row (odd index) */
      border-bottom: 0 !important;
      /* Add any additional styles here */
    }
    // &:first-child,
    // &:nth-child(2) {
    //   border-top: 1px solid #d9d9d9;
    // }
  }

  &.no-border {
    border: none;
  }
  
  &.custom-field-0{
    border-top: 1px solid rgb(224, 224, 227);
  }
  @media (max-width: 768px) {
    margin: 0px 10px;
    &:nth-child(odd) {
      border-right: 0px solid #ccc !important;
    }
    &:last-child:nth-child(odd) {
      border-bottom: 0px solid #d9d9d9 !important;
    }
    &.custom-field-0{
      border-top: 1px solid rgb(224, 224, 227);
    }
  }
`;

export const TrBody = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  &.profile {
    padding: 30px 20px;
  }
  &.invoiceData {
    max-width: 50%;
    margin: auto;
  }
  /* &.double {
    display: grid;
    grid-template-columns: 1fr 1fr;
  } */
  @media (max-width: 768px) {
    &.double {
      display: flex;
    }
      &.invoiceData {
    max-width: 100%;
    margin: auto;
  }
  }
`;
export const Title = styled.span`
  margin-right: 5px;
  margin-bottom: 5px;
  color: #838894;
  min-width: 150px;
  &.bold {
    font-weight: bold;
    color: black;
    margin: 0;
  }
`;
export const Head = styled.span`
  font-weight: bold;
  width: "100%";
  display: flex;
  align-items: "center";
  padding: 15px 17px 15px 26px;
  svg {
    margin-right: 10px;
  }
`;
export const DataHead = styled.span`
  padding: 10px 5px;
`;
export const DataItem = styled.span`
  font-weight: bold;
  border-radius: 10px;
  text-align: right;
  button {
    margin: 0;
    padding: 10px;
  }
  &.checkbox{
    border-radius: 20px;
  }
`;
export const TabContainer = styled.div`
  border-radius: 12px;
  padding: 10px;
  margin: 0;
  flex-direction: row;
  display: flex;
  column-gap: 10px;
  &.files {
    flex-direction: column;
  }
  @media (max-width: 768px) {
    margin: 0;
    &.vertical {
      flex-direction: column;
    }
  }
`;
export const TabList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  // border-radius: 10px;
  overflow: hidden;
  // border: 1px solid #d9d9d9;
  margin-top: 10px;
  @media (max-width: 768px) {
    flex-direction: row;
    overflow: auto;
    width: 100%;
  }
`;
export const Profile = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 130px;
  flex-direction: column;

  img {
    width: 50px;
    height: 50px;
    margin: auto;
    object-fit: cover;
    border-radius: 50%;
  }

  &.photo{
    height: 150px;
  }

  h6 {
    text-align: center;
    padding: 0px 12px 0px 12px;
    margin: 0;
    margin-bottom: 10px;
    font-size: 15px;
  }
  @media (max-width: 768px) {
    padding: 20px;
    width: -webkit-fill-available;
    &.vertical {
      flex-direction: column;
    }
  }
`;
export const TabItems = styled.div`
  margin: 0px;
  margin-top: 10px;
  flex: 1;
  max-width: calc(100% - 150px);
  &.false {
    max-width: 100%;
  }
  @media (max-width: 768px) {
    max-width: 100%;
  }
`;
export const TabText = styled.div`
  padding: 10px 10px;
  &.fileCount{
    background-color: grey;
    color: white;
    padding: 3px 8px;
    border-radius: 15px;
    margin-right: 10px;
  }
  &.active{
    background-color: #ffffff;
    color: #007bff
  }
  
`;
export const TabHead = styled.div`
  padding: 15px 30px;
  // color: blue;
  font-size: 18px;
  font-weight: 500;
  &.true{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;

export const Container = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
`;

export const CommentBox = styled.div`
  border: 1px solid #ccc;
  padding: 15px;
  margin-bottom: 15px;
  border-radius: 8px;
  background-color: #f9f9f9;
  display: inline-block;
  max-width: 80%; // Adjust this value as needed
`;

export const CommentHeader = styled.div`
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
`;

export const CommentText = styled.p`
  margin: 0;
  color: #555;
  word-wrap: break-word;
  text-align: left !important;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
`;

export const Button = styled.button`
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }
`;

export const Status = styled.div`
  font-weight: bold;
  margin-bottom: 20px;
  color: ${(props) => (props.status === "Resolved" ? "green" : "red")};
`;

export const FileCategory = styled.div`
  margin: 25px 10px;
  min-width: 250px;
  @media (max-width: 768px) {
    margin: 0 10px 10px 10px;
  }
`;

export const FileTitle = styled.div`
  margin: 10px;
`;

export const CaseHistoryViewTab = styled.div`
  width: calc(100% - 20px);
  display: flex;
  justify-content: end;
  margin-right: 20px;
`
export const CaseHistoryViewButton = styled.button`
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
  background: #3FC4FD;
  color: #FFFFFF;
  padding: 4px 5px;
  border-radius: 10px;
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  outline: 0px;
  border: 0px;
  margin: 0px;
  cursor: pointer;
  padding: 0.5em 1em;
  margin-right: 0em;
  outline: none;
  height: 40px;
  border: 0px solid #ddd;
  margin-left: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;

  &:hover {
    color: ${(props) => props.theme.bgPrimary};
    transform: scale(1.03);
  }

  @media (max-width: 768px) {
    justify-content: center;
    white-space: nowrap;
    font-size: 14px;
  }
`
